import React, { useContext } from 'react';
import { arrayOf, number, oneOfType, shape, string } from 'prop-types';
import {
  arrayOf as arrayOfType,
  extend,
  params,
  shape as shapeType,
  string as stringType,
  bool as boolType,
  QueryProvider,
  QueryContext
} from '@thd-nucleus/data-sources';
import {
  Badge,
  Carousel
} from '@thd-olt-component-react/core-ui';
import { Price } from '@thd-olt-component-react/price';
import { Fulfillment } from '@thd-olt-component-react/fulfillment';
import { DetailsCard } from './DetailsCard';
import './styles/details.scss';
import './styles/overrides.scss';
import { detailsDataModel } from './DetailsDataModel';
import { dynamicRecsDataModel } from './dataModel';

const Details = ({ storeId, carouselSkus }) => {
  const anchorClass = carouselSkus?.length > 1 ? 'details__carousel-anchor' : 'details';
  const { defaultVariables } = useContext(QueryContext);
  const newDefaultVariables = {
    storeId, 
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };
  return (
    <QueryProvider
      dataSource="dynamicRecs"
      defaultVariables={newDefaultVariables}
      cacheKey="visually-similar"
    >
      <div className="details__container">
        <div className="details__badge--wrapper">
          <Badge type="text" className="details__badge" text="Similar Item" />
        </div>
        <Carousel
          breakpoints={{
            sm: {
              slidesPerView: 1,
              slidesPerGroup: 1
            },
            md: {
              slidesPerView: 1,
              slidesPerGroup: 1
            },
            lg: {
              slidesPerView: 1,
              slidesPerGroup: 1
            },
            xl: {
              slidesPerView: 1,
              slidesPerGroup: 1
            }
          }}
          pagination
          peek={false}
          navigation
          slidesPerGroup={1}
          slidesPerView={1}
        >
          {carouselSkus.map((visSimSku, index) => {
            return (
              <DetailsCard
                product={visSimSku}
                anchorClass={anchorClass}
                index={index}
                storeId={storeId}
                key={index}
              />
            );
          })}
        </Carousel>
      </div>
    </QueryProvider>
  );
};

Details.dataModel = extend({},
  dynamicRecsDataModel,
  detailsDataModel,
  Fulfillment,
  Price
);

Details.propTypes = {
  storeId: string.isRequired,
  carouselSkus: arrayOf(shape({
    itemId: string
  })).isRequired
};

export { Details };
